import "./Skill.scss";
import React, { useEffect, useState } from "react";
import AnimateLetters from "../../components/AnimateLetters";
import FlipCard from "../../components/FlipCard";
import SQL from "../../assets/images/sql.png";
import felib from "../../assets/images/FrontEnd Libraries Certification.png";
import boot from "../../assets/images/bootcamp.png";
import css from "../../assets/images/css.png";
import kod from "../../assets/images/kod.png";

function Projects() {
  const [letterClass, setLetterClass] = useState("animate-text");
  const projectsArray = ["S", "k", "i", "l", "l", "s"];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <div className="container projects-page">
        <div className="text-zone">
          <h1>
            <AnimateLetters
              letterClass={letterClass}
              strArray={projectsArray}
              idx={15}
            />
          </h1>
        </div>

        <div className="project-cards">
          <p>
            🚀 Committed to refining my full-stack proficiency, I thrive on
            troubleshooting bugs and introducing innovative features across both
            front-end and back-end components of web applications.
          </p>
          <p>
            💼 Currently delving into the realms of HTML, CSS, JavaScript, Core
            Java, Web Components,SpringBoot,Redux,bootstrap, and React, I am
            consistently broadening my expertise as a Full-Stack Software
            Developer.
          </p>
          <p>
            🌱 Equipped with a solid foundation in Computer Science and
            Engineering, I am fervently dedicated to crafting accessible
            products and enhancing user experiences for optimal engagement.
          </p>

          <div className="languages-and-tools">
            <h3 align="left">Languages and Tools:</h3>
            <p align="left">
              {" "}
              <a
                href="https://www.arduino.cc/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://cdn.worldvectorlogo.com/logos/arduino-1.svg"
                  alt="arduino"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://getbootstrap.com"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/bootstrap/bootstrap-plain-wordmark.svg"
                  alt="bootstrap"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.w3schools.com/css/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original-wordmark.svg"
                  alt="css3"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://firebase.google.com/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                  alt="firebase"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://git-scm.com/" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
                  alt="git"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.w3.org/html/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original-wordmark.svg"
                  alt="html5"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://www.java.com" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
                  alt="java"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg"
                  alt="javascript"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.mongodb.com/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg"
                  alt="mongodb"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://www.mysql.com/" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg"
                  alt="mysql"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://nextjs.org/" target="_blank" rel="noreferrer">
                {" "}
              </a>{" "}
              <a
                href="https://www.oracle.com/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/oracle/oracle-original.svg"
                  alt="oracle"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.photoshop.com/en"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/photoshop/photoshop-line.svg"
                  alt="photoshop"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.postgresql.org"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/postgresql/postgresql-original-wordmark.svg"
                  alt="postgresql"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://postman.com" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg"
                  alt="postman"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://reactjs.org/" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original-wordmark.svg"
                  alt="react"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a href="https://spring.io/" target="_blank" rel="noreferrer">
                {" "}
                <img
                  src="https://www.vectorlogo.zone/logos/springio/springio-icon.svg"
                  alt="spring"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://tailwindcss.com/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg"
                  alt="tailwind"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
              <a
                href="https://www.typescriptlang.org/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
              </a>{" "}
              <a
                href="https://www.adobe.com/products/xd.html"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                <img
                  src="https://cdn.worldvectorlogo.com/logos/adobe-xd.svg"
                  alt="xd"
                  width="40"
                  height="40"
                />{" "}
              </a>{" "}
            </p>
          </div>

          <FlipCard
            projectName={"Front End Development Libraries Certification"}
            title={"Front End Development Libraries Certification"}
            description={"jQuery, Bootstrap, React, Redux & SASS"}
            //projectLink={'https://animebutler.herokuapp.com'}
            linkedinLink={
              "https://www.linkedin.com/in/rahul-googikoll-121360275/overlay/1709214351653/single-media-viewer/?profileId=ACoAAEMmWqkBcHC65m-9jDTQKpmq0EWq2a0XyV0"
            }
            img={felib}
          />

          <FlipCard
            projectName={
              "The Complete SQL Bootcamp: Go from Zero to Hero UDEMY"
            }
            title={"The Complete SQL Bootcamp: Go from Zero to Hero"}
            description={"SKILLS: PostGreSql, MySQL, NoSQL"}
            githubLink={
              "https://www.linkedin.com/in/rahul-googikoll-121360275/details/certifications/1705607427673/single-media-viewer/?profileId=ACoAAEMmWqkBcHC65m-9jDTQKpmq0EWq2a0XyV0"
            }
            img={SQL}
          />

          <FlipCard
            projectName={"The Web Developer Bootcamp 2024"}
            title={"The Web Developer Bootcamp 2024"}
            description={"SKILLS: React · Node.js · MongoDB · Express.js"}
            githubLink={
              "https://www.linkedin.com/in/rahul-googikoll-121360275/details/certifications/1708174638635/single-media-viewer/?profileId=ACoAAEMmWqkBcHC65m-9jDTQKpmq0EWq2a0XyV0"
            }
            img={boot}
          />
          <FlipCard
            projectName={"Java full stack developer KodNest"}
            title={"Java full stack developer KodNest"}
            description={
              "Skills: Spring Boot · Spring Framework · Hibernate · Spring MVC · Core Java · JavaScript · React.js"
            }
            githubLink={
              "https://www.linkedin.com/in/rahul-googikoll-121360275/details/certifications/1708685735830/single-media-viewer/?profileId=ACoAAEMmWqkBcHC65m-9jDTQKpmq0EWq2a0XyV0"
            }
            img={kod}
          />
          <FlipCard
            projectName={"Responsive Web Design"}
            title={"Responsive Web Design"}
            description={
              "HTML (Hypertext Markup Language) for content, and CSS (Cascading Style Sheets) for design."
            }
            githubLink={
              "https://www.linkedin.com/in/rahul-googikoll-121360275/details/certifications/1706507630131/single-media-viewer/?profileId=ACoAAEMmWqkBcHC65m-9jDTQKpmq0EWq2a0XyV0"
            }
            img={css}
          />
        </div>
      </div>
    </>
  );
}

export default Projects;
